import normalShoulders from "/public/Images/normalShoulders.png"
import slopingShoulders from "/public/Images/slopingShoulders.png"

export const bf5 = [
  {
    id: 1,
    type: "prompt",
    content: "straps falling can either be that the bra straps have lost their friction (if it's an everyday bra that is 6+ months old) or your shoulder shape. Let’s first check if your shoulders shape. Which shoulder shape do you identify with?",
    options: [{ label: "Start Quiz", next: 2 }],
    next: 2,
  }, // braSizeInput
  {
    id: 2,
    type: "promptWithImages",
    content:
      "Thanks for that, now, let’s put your bra on. Which image below resonates with your current fit the most?",
    options: [
      {
        label: "Sloping",
        image: slopingShoulders,
        next: 3,
      },
      {
        label: "Regular",
        image: normalShoulders,
        next: 4,
      },
    ],
    next: 4,
  },


  {
    id: 3,
    type: "result",
    content:
      "We suggest that bra-wearers with sloping shoulders look out for convertible straps or halter-neck bras, and to avoid full-cup bras where the straps tend to sit further apart. \n Here are some suitable which I think you will like. Feel free to ask me any questions to narrow down the selections! ",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
  {
    id: 4,
    type: "result",
    content: "Thanks! In this case, it’s most likely that your bra needs replacing. Here are some best-selling bras which I think you will like. Feel free to ask me any questions to narrow down the selections!",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
];
